import React from "react";
import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import BenefitAddReview from "ComponentsUI/Benefit/Components/BenefitAddReview";
import { generateUrl } from "Services/withDefaultParams";
import withDefaultParams from "Services/withDefaultParams";
var Routes = require("Configs/routes");

@withRouter
@withDefaultParams
@inject("ApplicationModel")
@observer
export default class AddReviewBlock extends React.Component {
	render() {
		let text = this.props.ApplicationModel.text;
		let feedbackUrl = generateUrl(Routes.AddReview.route, {
			regionUrl: this.props.match.params.regionUrl,
		});
		return <BenefitAddReview text={text} link={feedbackUrl} />;
	}
}
